"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _lodash2 = _interopRequireDefault(require("lodash.sortby"));

var _lodash3 = _interopRequireDefault(require("lodash.get"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _getValueFromGenericInput = require("@devsta/get-value-from-generic-input");

var _ShotList = _interopRequireDefault(require("./ShotList"));

var _TabDrawer = _interopRequireDefault(require("./TabDrawer"));

var _ImportScriptModal = _interopRequireDefault(require("./ImportScriptModal"));

require("../styles/index.scss");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var AutoSaveComponent = (0, _commonReact.requiresPermission)({
  ComponentToRender: _commonReact.Autosave,
  requiredPermission: 'UPDATE'
});

var EditStoryboardRoot = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EditStoryboardRoot, _Component);

  function EditStoryboardRoot(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EditStoryboardRoot);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EditStoryboardRoot).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleStoryboardFieldChange", (0, _lodash.default)(function (field) {
      return function (value) {
        _this.setState(function (_ref) {
          var storyboard = _ref.storyboard;
          return {
            storyboard: _objectSpread({}, storyboard, (0, _defineProperty2.default)({}, field, (0, _getValueFromGenericInput.getStringValueFromGenericInput)(value)))
          };
        });
      };
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectTemplate", (0, _lodash.default)(function (index) {
      return function () {
        _this.setState(function (_ref2) {
          var selectedTemplateIndex = _ref2.selectedTemplateIndex;
          return {
            selectedTemplateIndex: index === selectedTemplateIndex ? void 0 : index
          };
        });
      };
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setModal", (0, _lodash.default)(function (modal) {
      return function () {
        _this.setState({
          modal: modal
        });
      };
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchStoryboard", function _callee() {
      var getStoryboard, _ref3, data, error;

      return _regenerator.default.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getStoryboard = _this.props.getStoryboard;
              _context.next = 3;
              return _regenerator.default.awrap(getStoryboard());

            case 3:
              _ref3 = _context.sent;
              data = _ref3.data;
              error = _ref3.error;

              if (!error) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", {
                error: error
              });

            case 8:
              return _context.abrupt("return", {
                storyboard: data.getStoryboard,
                templates: data.getTemplates
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchScripts", function _callee2(organisationId) {
      var getScripts, _ref4, data, error;

      return _regenerator.default.async(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              getScripts = _this.props.getScripts;
              _context2.next = 3;
              return _regenerator.default.awrap(getScripts(organisationId));

            case 3:
              _ref4 = _context2.sent;
              data = _ref4.data;
              error = _ref4.error;

              if (!error) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", {
                error: error
              });

            case 8:
              return _context2.abrupt("return", {
                scripts: data.getScripts
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateShots", function (shots) {
      var updatedScriptArray = shots.map(function (_ref5) {
        var script = _ref5.script;
        return script;
      }).filter(Boolean);
      var script = updatedScriptArray.join('\n\n');

      _this.setState({
        shots: shots,
        script: script
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateAssets", function (assetIds) {
      _this.setState(function (_ref6) {
        var storyboard = _ref6.storyboard;
        return {
          storyboard: _objectSpread({}, storyboard, {
            assetIds: assetIds
          })
        };
      }, function () {
        var _this$state = _this.state,
            storyboard = _this$state.storyboard,
            shots = _this$state.shots;

        _this.handleUpdateStoryboard({
          storyboard: storyboard,
          shots: shots
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectShot", function (selectedShotIndex) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return function () {
        _this.setState({
          selectedShotIndex: selectedShotIndex
        });

        if (options.animate) {
          var shot = document.getElementById("shot-".concat(selectedShotIndex));
          var shotOffset = (0, _lodash3.default)(shot, 'offsetLeft', null);

          if (!shotOffset) {
            return;
          }

          var shotList = document.querySelector('.shot-list__inner');

          if (!shotList) {
            return;
          }

          shotList.scrollLeft = shotOffset - 50;
        }
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleUpdateStoryboard", function _callee3(_ref7) {
      var storyboard, shots, updateStoryboard;
      return _regenerator.default.async(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              storyboard = _ref7.storyboard, shots = _ref7.shots;

              if (storyboard) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return");

            case 3:
              updateStoryboard = _this.props.updateStoryboard;

              _this.setState({
                saving: true
              });

              _context3.next = 7;
              return _regenerator.default.awrap(updateStoryboard({
                storyboard: storyboard,
                shots: shots
              }));

            case 7:
              _this.setState({
                saving: false
              });

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTabSelect", function (selectedTabIndex) {
      var TEMPLATE_TAB = 2;

      if (selectedTabIndex !== TEMPLATE_TAB) {
        _this.cancelTemplate();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "saveAndExit", function _callee4() {
      var _this$state2, storyboard, shots;

      return _regenerator.default.async(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$state2 = _this.state, storyboard = _this$state2.storyboard, shots = _this$state2.shots;

              if (!storyboard) {
                _context4.next = 5;
                break;
              }

              _context4.next = 4;
              return _regenerator.default.awrap(_this.handleUpdateStoryboard({
                storyboard: storyboard,
                shots: shots
              }));

            case 4:
              _this.close();

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "close", function () {
      var history = _this.props.history;
      history.push('/');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cancelTemplate", function () {
      _this.setState({
        selectedTemplateIndex: void 0
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "saveTemplate", function () {
      return void _this.setState(function (_ref8) {
        var templates = _ref8.templates,
            selectedTemplateIndex = _ref8.selectedTemplateIndex;

        if (selectedTemplateIndex === void 0) {
          return {};
        }

        var shots = templates[selectedTemplateIndex].shots;
        var shotsWithTempId = shots.map(function (_ref9) {
          var shotId = _ref9.shotId,
              rest = (0, _objectWithoutProperties2.default)(_ref9, ["shotId"]);
          return _objectSpread({}, rest, {
            tempId: shotId
          });
        });
        return {
          shots: shotsWithTempId,
          selectedTemplateIndex: void 0
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "importScript", function (selectedScriptIndex) {
      return function () {
        var _this$state3 = _this.state,
            scripts = _this$state3.scripts,
            shots = _this$state3.shots;
        var content = scripts[selectedScriptIndex].content;

        _this.updateShots([].concat((0, _toConsumableArray2.default)(shots), [{
          script: content,
          name: '',
          tempId: Date.now()
        }]));
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleBlurTitle", function _callee5() {
      var _this$state4, storyboard, shots;

      return _regenerator.default.async(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this$state4 = _this.state, storyboard = _this$state4.storyboard, shots = _this$state4.shots;

              if (!storyboard) {
                _context5.next = 4;
                break;
              }

              _context5.next = 4;
              return _regenerator.default.awrap(_this.handleUpdateStoryboard({
                storyboard: storyboard,
                shots: shots
              }));

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleButtonClick", function (_ref10) {
      var isTemplateActive = _ref10.isTemplateActive;
      return function () {
        var hasUpdatePermission = _this.state.hasUpdatePermission;

        if (hasUpdatePermission) {
          return isTemplateActive ? _this.saveTemplate() : _this.saveAndExit();
        }

        return isTemplateActive ? void 0 : _this.close();
      };
    });
    _this.state = {
      scripts: [],
      templates: [],
      shots: [],
      script: '',
      modal: '',
      selectedShotIndex: 0,
      saving: false,
      hasUpdatePermission: false,
      hasDeletePermission: false
    };
    return _this;
  }

  (0, _createClass2.default)(EditStoryboardRoot, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props, fetchCollaborationData, fetchAssetsForResource, _ref11, error, storyboard, templates, _storyboard$shots, shots, organisationId, storyboardId, _ref12, scripts, scriptsError, hasUpdatePermission, hasDeletePermission, sortedShots;

      return _regenerator.default.async(function componentDidMount$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this$props = this.props, fetchCollaborationData = _this$props.fetchCollaborationData, fetchAssetsForResource = _this$props.fetchAssetsForResource;
              _context6.next = 3;
              return _regenerator.default.awrap(this.fetchStoryboard());

            case 3:
              _ref11 = _context6.sent;
              error = _ref11.error;
              storyboard = _ref11.storyboard;
              templates = _ref11.templates;

              if (!error) {
                _context6.next = 9;
                break;
              }

              return _context6.abrupt("return", void this.setState({
                error: error
              }));

            case 9:
              if (storyboard) {
                _context6.next = 11;
                break;
              }

              return _context6.abrupt("return", void this.setState({
                storyboard: storyboard
              }));

            case 11:
              _storyboard$shots = storyboard.shots, shots = _storyboard$shots === void 0 ? [] : _storyboard$shots, organisationId = storyboard.organisationId, storyboardId = storyboard.storyboardId;
              _context6.next = 14;
              return _regenerator.default.awrap(this.fetchScripts(organisationId));

            case 14:
              _ref12 = _context6.sent;
              scripts = _ref12.scripts;
              scriptsError = _ref12.error;

              if (!scriptsError) {
                _context6.next = 19;
                break;
              }

              return _context6.abrupt("return", void this.setState({
                error: scriptsError
              }));

            case 19:
              hasUpdatePermission = (0, _commonReact.hasPermission)('UPDATE', storyboard.permissions);
              hasDeletePermission = (0, _commonReact.hasPermission)('DELETE', storyboard.permissions);
              fetchAssetsForResource({
                data: storyboard,
                resourceId: storyboardId,
                organisationId: organisationId
              });
              templates.forEach(function (template) {
                fetchAssetsForResource({
                  data: template,
                  resourceId: template.storyboardId,
                  organisationId: template.organisationId
                });
              });
              fetchCollaborationData(organisationId);
              sortedShots = (0, _lodash2.default)(shots, 'position');
              return _context6.abrupt("return", void this.setState({
                templates: templates,
                storyboard: storyboard,
                scripts: scripts || [],
                shots: sortedShots,
                hasUpdatePermission: hasUpdatePermission,
                hasDeletePermission: hasDeletePermission
              }));

            case 26:
            case "end":
              return _context6.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state5 = this.state,
          storyboard = _this$state5.storyboard,
          shots = _this$state5.shots,
          selectedShotIndex = _this$state5.selectedShotIndex,
          templates = _this$state5.templates,
          selectedTemplateIndex = _this$state5.selectedTemplateIndex,
          script = _this$state5.script,
          scripts = _this$state5.scripts,
          modal = _this$state5.modal,
          saving = _this$state5.saving,
          hasUpdatePermission = _this$state5.hasUpdatePermission,
          hasDeletePermission = _this$state5.hasDeletePermission,
          error = _this$state5.error;

      if (error) {
        return _react.default.createElement(_commonReact.Error, null);
      }

      if (storyboard === null) {
        return _react.default.createElement(_commonReact.NotFound, null);
      }

      if (storyboard === void 0) {
        return _react.default.createElement(_uiKit.Loader, null);
      }

      var isTemplateActive = selectedTemplateIndex !== void 0;
      var actionBtnText = hasUpdatePermission ? 'Save & Close' : 'Close';
      var storyboardPermissions = storyboard.permissions;
      return _react.default.createElement("div", {
        className: "storyboard page page__full",
        tabIndex: 0,
        role: "button"
      }, _react.default.createElement(AutoSaveComponent, {
        functionToCall: this.handleUpdateStoryboard,
        data: {
          storyboard: storyboard,
          shots: shots
        },
        permissions: storyboardPermissions
      }), _react.default.createElement("div", {
        className: "storyboard__container"
      }, _react.default.createElement(_ImportScriptModal.default, {
        scripts: scripts,
        visible: modal === 'import-script',
        onClose: this.setModal(''),
        onSave: this.importScript
      }), _react.default.createElement("div", {
        className: "storyboard__container__content"
      }, _react.default.createElement(_commonReact.CollaborationPageHeader, {
        editableTitle: hasUpdatePermission,
        onBlurTitle: this.handleBlurTitle,
        onChangeTitle: this.handleStoryboardFieldChange('name'),
        title: storyboard.name,
        titlePlaceHolder: "New Storyboard",
        subtitle: "Project Name",
        actionBtnMobileIcon: isTemplateActive ? 'success' : 'exit',
        actionBtnBusy: saving,
        secondaryContent: isTemplateActive ? _react.default.createElement(_uiKit.LinkButton, {
          onClick: this.cancelTemplate
        }, "Cancel") : null,
        actionBtnOnClick: this.handleButtonClick({
          isTemplateActive: isTemplateActive
        }),
        actionBtnText: isTemplateActive ? 'Use Template' : actionBtnText,
        actionPopupBackgroundColor: "catSkillWhite"
      }), _react.default.createElement(_ShotList.default, {
        handleStoryboardFieldChange: this.handleStoryboardFieldChange,
        shots: shots,
        template: selectedTemplateIndex !== void 0 ? templates[selectedTemplateIndex] : void 0,
        updateAssets: this.updateAssets,
        updateShots: this.updateShots,
        selectShot: this.selectShot,
        selectedShotIndex: selectedShotIndex,
        hasDeletePermission: hasDeletePermission,
        storyboardPermissions: storyboardPermissions,
        hasUpdatePermission: hasUpdatePermission,
        storyboard: storyboard
      })), _react.default.createElement(_TabDrawer.default, {
        templates: templates,
        selectShot: this.selectShot,
        selectedShotIndex: selectedShotIndex,
        selectTemplate: this.selectTemplate,
        selectedTemplateIndex: selectedTemplateIndex,
        updateShots: this.updateShots,
        updateAssets: this.updateAssets,
        script: script,
        shots: shots,
        onTabSelect: this.onTabSelect,
        setModal: this.setModal,
        handleStoryboardFieldChange: this.handleStoryboardFieldChange,
        storyboard: storyboard,
        hasUpdatePermission: hasUpdatePermission
      })));
    }
  }]);
  return EditStoryboardRoot;
}(_react.Component);

var _default = EditStoryboardRoot;
exports.default = _default;